<template>
  <v-tabs class="sub-menu" slider-color="primary" height="64" style="margin-bottom: 15px;" background-color="transparent">
    <v-tab class="sub-menu-item" to="/optima/settings/category">
      <v-icon class="sub-menu-item-icon">fa-columns</v-icon>
      {{ $t("optima.category") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/optima/settings/employee">
      <v-icon class="sub-menu-item-icon">fa-address-book</v-icon>
      {{ $t("optima.employee") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/optima/settings/contractor">
      <v-icon class="sub-menu-item-icon">fa-address-card</v-icon>
      {{ $t("optima.contractor") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "OptimaMenu",
  mounted() {
    this.$store.dispatch("Visual/setMenuBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>

<style>
.sub-menu .v-tabs__bar {
  background-color: inherit;
}
</style>
